<template>
  <div id="app">
    <router-view v-if="permission" />
    <div class="erorr" v-else>
      <img class="" src="./assets/img/404.png" alt="">
    </div>
  </div>
</template>

<script>
  import {
    AccessPermission
  } from './api/apiFun'
  export default {
    name: "App",
    data() {
      return {
        permission: true
      }
    },
    created() {
      this.AccessPermission()
    },

    methods: {
      AccessPermission() {
        AccessPermission().then(res => {
          if (res.code == 400) {
            this.permission = false
          }
        }).catch(err => {})
      },
    }
  };

</script>

<style>
  html,
  body {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0px;
    margin: 0px;
  }

  #app {
    font-family: Inter, Helvetica Neue, sans-serif;
    color: #2c3e50;
    width: 100%;
    height: 100%;
  }

  .el-header {
    padding: 0;
    height: 70px !important;
  }

  .el-container {
    height: 100vh;
    overflow-y: auto;
  }

  .el-main {
    background: #F9FBFD;
  }

  .el-aside {
    max-width: 220px;
    min-width: 220px;
  }

  .left_nav_hide {
    max-width: 66px;
    min-width: 66px;
  }

  .cur_route {
    color: #063a4f;
    font-family: Inter, Helvetica Neue, sans-serif;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 36px;
    letter-spacing: .0126316em;
    margin-bottom: 10px;
  }

  .el-breadcrumb__inner a:hover,
  .el-breadcrumb__inner.is-link:hover {
    color: #21cccf;
  }

  .el-breadcrumb__inner.is-link {
    color: rgba(0, 0, 0, .45);
    transition: color .3s;
    font-weight: normal;
  }

  .el-breadcrumb__item:last-child .el-breadcrumb__inner,
  .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
  .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
  .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
    color: #00b8c2;
  }

  .div_cont {
    background: #fff;
    padding: 0px 20px 10px 20px
  }

  .el-table {
    border: 0.5px solid rgba(0, 0, 0, .1);
    box-shadow: 0 2px 3px rgba(13, 79, 100, .1);
    border-radius: 5px;
    /* display: inline-table; */
  }

  .el-dialog {
    max-height: 70%;
    overflow-y: scroll;
  }

  .el-message {
    min-width: auto !important;
    left: 88% !important;
  }

  .erorr {
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .erorr img {
    width: 1014px;
    height: 556px;
  }

  .frw {
    display: flex;
    flex-direction: row;
  }

  .fcl {
    display: flex;
    flex-direction: column;
  }

  .f1 {
    flex: 1;
  }

  .fjb {
    justify-content: space-between;
  }

  .fja {
    justify-content: space-around;
  }

  .fje {
    justify-content: flex-end;
  }

  .fjs {
    justify-content: flex-start;
  }

  .fjc {
    justify-content: center;
  }

  .fae {
    align-items: flex-end;
  }

  .fac {
    align-items: center;
  }

  .fas {
    align-items: flex-start;
  }

  .fab {
    align-items: baseline;
  }

  .fw {
    flex-wrap: wrap;
  }

  .fasc {
    align-self: center;
  }

  .fass {
    align-self: flex-start;
  }

  .fase {
    align-self: flex-end;
  }

  .fs {
    flex-shrink: 0;
  }

  .frwfacfjb {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .box-sizing {
    box-sizing: border-box;
  }

  .nowrap-space {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .nowrap-space2 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue